import apiClient from "./apiClient";
import {
  ShiftCrossReferenceOtShiftOption,
  ShiftCrossReferenceResponse,
  ShiftCrossReferenceSaveRequest,
  ShiftEventsResponse,
  ShiftGridRequest,
  ShiftGridResponse,
  ShiftHubOption,
  ShiftLogSheetResponse,
  ShiftLookupsRequest,
  ShiftLookupsResponse,
  ShiftSaveRequest,
  ShiftSaveResponse,
  ShiftTypeGridRequest,
  ShiftTypeGridResponse,
  ShiftTypeSaveRequest,
} from "shifts/models";

const getHubs = async (): Promise<ShiftHubOption[]> => apiClient.get(`/shifts/hubs`);

const getShiftGrid = async (request: ShiftGridRequest): Promise<ShiftGridResponse> =>
  apiClient.post(`/shifts/grid`, request);

const getLookups = async (request: ShiftLookupsRequest): Promise<ShiftLookupsResponse> =>
  apiClient.post(`/shifts/lookups`, request);

const saveShifts = async (request: ShiftSaveRequest): Promise<ShiftSaveResponse> =>
  apiClient.post(`/shifts/save`, request);

const getShiftEvents = async (yardDailyId: number): Promise<ShiftEventsResponse> =>
  apiClient.get(`/shifts/${yardDailyId}/events`);

const getShiftTypes = async (request: ShiftTypeGridRequest): Promise<ShiftTypeGridResponse> =>
  apiClient.post(`/shifts/types`, request);

const saveShiftTypes = async (request: ShiftTypeSaveRequest): Promise<ShiftSaveResponse> =>
  apiClient.post(`/shifts/types/save`, request);

const getCrossReferenceLocations = async (): Promise<string[]> =>
  apiClient.get(`/shifts/crossreference/locations`);

const getCrossReference = async (upLocation: string): Promise<ShiftCrossReferenceResponse> =>
  apiClient.post(`/shifts/crossreference`, { upLocation });

const getOtShifts = async (hubId: number): Promise<ShiftCrossReferenceOtShiftOption[]> =>
  apiClient.get(`/shifts/crossreference/otshifts/${hubId}`);

const saveCrossReference = async (request: ShiftCrossReferenceSaveRequest): Promise<ShiftSaveResponse> =>
  apiClient.post(`/shifts/crossreference/save`, request);

const getLogSheet = async (shiftOrControlNumber: string): Promise<ShiftLogSheetResponse> =>
  apiClient.post(`/shifts/logsheet`, { shiftOrControlNumber });

const getLogSheetPdf = async (shiftOrControlNumber: string): Promise<Blob> =>
  apiClient.postBlob(`/shifts/logsheet/pdf`, { shiftOrControlNumber });

const shiftManagementService = {
  getHubs,
  getShiftGrid,
  getLookups,
  saveShifts,
  getShiftEvents,
  getShiftTypes,
  saveShiftTypes,
  getCrossReferenceLocations,
  getCrossReference,
  getOtShifts,
  saveCrossReference,
  getLogSheet,
  getLogSheetPdf,
};

export default shiftManagementService;
